import React from 'react';
import Monitoring from './Monitoring';
import { Container } from 'react-bootstrap';
import Comparison from './Comparison';

function Public() {
  return (
    <Container style={{ maxWidth: '1200px' }}>
      <Monitoring />
    </Container>
  );
}

export default Public;
